import {EndoMultiToothExamDataModel} from '../../../../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import {EndoMultiToothExamToothDataModel} from '../../../../../../../models/forms/custom/mti/endo-multi-tooth-exam-tooth-data.model';

export class MtiPriorExamModel {
  exam: EndoMultiToothExamDataModel;
  tooth: EndoMultiToothExamToothDataModel;
  isSelected: boolean = false;
}
